import React from 'react';
import { Col, Row } from 'react-styled-flexboxgrid';
import styled from 'styled-components';
import Page from '../components/Page';
import Icon from '../assets/kamera_blau_klein.gif';

// STYLES
const List = styled.ul`
  list-style-image: url(${ Icon });
  margin-left: 20px;
`;

const ListItem = styled.li`
  margin-bottom: 1.2rem;

  &:last-child {
    margin-bottom: 0;
  }
`;

const ListLink = styled.a`
  text-decoration: none;
  font-weight: bold;
  transition: all 0.2s;
  display: inline-block;
  line-height: 1.2;

  &:hover {
    color: ${props => props.theme.color.secondary};
    text-decoration: none;
  }
`;

// COMPONENT
const AktuelleProjekte = props => {
  
  console.log(props);
  const { data } = props;

  return (
    <Page title="Aktuelle Projekte">
      <Row>
        <Col xs={12} sm={6}>
          <img src={ process.env.REACT_APP_ROOT + data.image.path } alt="" />
        </Col>
        <Col xs={12} sm={6}>
          <List>
            { data.projects.map(project => (
              <ListItem><ListLink key={ project.value.file } href={ process.env.REACT_APP_ROOT + '/' + project.value.file } target="_blank" rel="noopener noreferrer">{ project.value.label }</ListLink></ListItem>
            )) }
          </List>
        </Col>
      </Row>
    </Page>
  );
};

export default AktuelleProjekte;